module.exports = __webpack_public_path__ + "static/xbox-logo-0e70ca028361dcbc07c58bf515b644c4.png";